export enum PaymentType {
	Credits = "Credits",
	GoPayApplePay = "GoPayApplePay",
	GoPayGPay = "GoPayGPay",
	GoPayPaymentCard = "GoPayPaymentCard",
	// GoPayPayPal = "GoPayPayPal",
	GoPayQRCode = "GoPayQRCode",
	OnDelivery = "OnDelivery",
	OnInvoice = "OnInvoice",
	Subscription = "Subscription",
	Voucher = "Voucher",
	WithoutInvoice = "WithoutInvoice",
}
